import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCall,
  postCall,
  deleteCall,
  getById,
  BASE_URL,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  userData: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getUser = createAsyncThunk(
  "User/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/all_user?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getUserById = createAsyncThunk("User/getById", async (id) => {
  try {
    const response = await getById("/admin/v1/show_user", id, false);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const addUser = createAsyncThunk("User/add", async (name) => {
  try {
    const response = await postCall("/admin/v1/add_user", name);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateUser = createAsyncThunk(
  "User/update",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_user/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message || "User updated successfully!");
      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "User/delete",
  async (id) => {
    try {
    
      await deleteCall(`/admin/v1/delete_user?user_id=${id}`);

      return await id;
    } catch (error) {
      return Promise?.reject(error);
    } finally {
    }
  });

const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getUserById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userData = action.payload;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.push(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateUser.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        // state.userData = action.payload;
        const index = state.data.data.findIndex(
          (user) => user.id === action.payload.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(deleteUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (User) => User.id !== action.payload
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default UserSlice.reducer;
